import { twMerge } from 'tailwind-merge';

/** Container classes shared by the remote video tile and the caller tile. */
export const getOuterContainerClass = (): string =>
    'remote-video relative flex h-full w-full overflow-hidden rounded-xl bg-black text-white';

export const getInnerContainerClass = (isFullscreenOrNarrow: boolean): string =>
    twMerge(
        'flex h-full w-full bg-black text-white',
        isFullscreenOrNarrow ? '' : 'sidebar',
    );
